import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productCategoriesApi } from "api/api/productCategoriesApi/productCategoriesApi";

export const getProductsCategoriesForInfinitySelect = createAsyncThunk<
  any,
  any
>("productCategories/getProductsCategoriesForInfinitySelect", async (params, { rejectWithValue }) => {
  try {
    const data = await productCategoriesApi.getProductsCategoriesForInfinitySelect(params);
    return data;
  } catch (error: unknown) {
    let message = "Что-то пошло не так... Попробуйте снова";
    if (axios.isAxiosError(error)) {
      console.error("Error while creating category", error.response?.data);
    } else {
      console.error("Error while creating category", error);
    }
    return rejectWithValue(message);
  }
});